import { useEffect, useState } from "react";
import { collection, addDoc, getDocs } from "firebase/firestore";
import { db } from "../firebase";

export default function GameLobby({ team, setGameId }) {
  const [games, setGames] = useState([]);

  useEffect(() => {
    const fetchGames = async () => {
      const querySnapshot = await getDocs(collection(db, "games"));
      setGames(querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    };
    fetchGames();
  }, []);

  const createGame = async () => {
    const now = new Date();
    
    // 🔹 한국 시간(KST) 변환
    const koreaTime = new Intl.DateTimeFormat("ko-KR", {
      year: "2-digit",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      timeZone: "Asia/Seoul"
    }).format(now);

    try {
      const docRef = await addDoc(collection(db, "games"), {
        roomName: `게임방 ${koreaTime.replace(/[^0-9 ]/g, "")}`,  // 🔹 YY-MM-DD HH:mm 형식
        status: "waiting",
        redPlayer: team === "red" ? "player" : null,
        bluePlayer: team === "blue" ? "player" : null,
        redAnswer: null,
        blueAnswer: null,
        turn: "red",  // 🔹 선공을 기본적으로 레드 팀으로 설정 (동전 던지기 삭제)
        history: [],
        winner: null,
        createdAt: now.toISOString() // 🔹 Firestore 저장 시 UTC 시간으로 저장 (하지만 UI에서는 KST 표시)
      });

      setGameId(docRef.id);
    } catch (error) {
      console.error("방 생성 실패:", error);
    }
  };

  return (
    <div className="container">
      <h1 className="text-3xl font-bold mb-6">게임 방 목록</h1>

      {games.map(game => (
        <button 
          key={game.id} 
          onClick={() => setGameId(game.id)} 
          className="px-6 py-3 bg-green-500 hover:bg-green-700 rounded-lg text-white font-semibold mb-2"
        >
          {game.roomName || "이름 없는 방"} {/* 🔹 Firestore 문서 ID 제거 */}
        </button>
      ))}

      <button onClick={createGame} className="px-6 py-3 bg-blue-500 hover:bg-blue-700 rounded-lg text-white font-semibold mt-4">
        새 게임 방 만들기
      </button>
    </div>
  );
}
